import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { userStateAtom } from "../atoms/userStateAtom";
import { formFlowAtom } from "./Atom/formFlowAtom";
import { writingDetailInfoAtom } from "./Atom/writingDetailInfoAtom";
import WebFrame from "../design/WebFrame";
import Table from "../design/Table";

const AddWordsSentencesForm = () => {
  const navigate = useNavigate();
  const user = useRecoilValue(userStateAtom);
  const userID = user.userData.userIdphp;
  const [flow, setFlow] = useRecoilState(formFlowAtom);
  const submittedForm = useRecoilValue(writingDetailInfoAtom);

  const dummy = {
    rowname: ["this", "is", "dummy"],
    contents: [
      {
        row1: "this",
        row2: "is",
        row3: "dummy",
      },
      {
        row1: "this",
        row2: "is",
        row3: "dummy",
      },
      {
        row1: "this",
        row2: "is",
        row3: "dummy",
      },
    ],
  };

  return (
    <WebFrame>
      <div className="text-3xl font-bold mb-5">데이터 추가📚💬</div>
      <Table tableData={dummy} />
    </WebFrame>
  );
};

export default AddWordsSentencesForm;
